import { render, staticRenderFns } from "./product_report.vue?vue&type=template&id=4f8103a8&scoped=true"
import script from "./product_report.vue?vue&type=script&lang=js"
export * from "./product_report.vue?vue&type=script&lang=js"
import style0 from "./product_report.vue?vue&type=style&index=0&id=4f8103a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8103a8",
  null
  
)

export default component.exports